export class ProjectsConst {
    public static MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME='Brother International GmbH';

    public static COLOR_PAGE_R_PRICE_ID = "COLOR";
    public static MONO_PAGE_R_PRICE_ID = "MONO";
}
